import * as React from "react";
const SvgFiRrBadminton = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-badminton_svg__a)">
      <path
        fill="#062147"
        d="M21.932 2.068C20.427.562 18.332-.167 16.04.03c-2.231.186-4.395 1.223-6.091 2.919S7.216 6.808 7.03 9.039c-.161 1.932.333 3.714 1.389 5.129l-2.935 2.935a2.14 2.14 0 0 0-2.14.524L.628 20.343a2.144 2.144 0 0 0 0 3.03 2.144 2.144 0 0 0 3.03 0l2.716-2.716a2.14 2.14 0 0 0 .524-2.14l2.935-2.935c1.238.923 2.756 1.418 4.411 1.418q.355 0 .718-.03c2.231-.186 4.395-1.223 6.091-2.92 1.696-1.695 2.733-3.858 2.919-6.09.191-2.294-.532-4.387-2.038-5.893zm.045 5.726c-.147 1.76-.978 3.48-2.34 4.843s-3.082 2.193-4.843 2.34c-1.699.142-3.229-.377-4.312-1.46s-1.601-2.613-1.459-4.311c.147-1.761.978-3.481 2.34-4.843s3.083-2.193 4.843-2.34Q16.481 2 16.751 2c1.479 0 2.802.517 3.768 1.482 1.083 1.083 1.601 2.614 1.459 4.312zm1.452 15.003A.864.864 0 0 1 22.635 24h-4.291a.864.864 0 0 1-.794-1.204l1.42-2.296v-1a1.5 1.5 0 0 1 3 0v1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-badminton_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBadminton;
